import ETC_AXIOS from '../api/etc.axios'
import APP from '../config/app.config'
import ETC from '../config/etc.config'

export default {
  getUserInfo() {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/profile/index')
  },
  // 获取用户当前订单状态
  getCurrentOrder(data) {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/apply/current-order', data)
  },
  /**
   * 发送手机号码验证码
   * @param {Number} sendPhone 手机号码
   */
  postSendPhoneVerificationCode(sendPhone) {
    return ETC_AXIOS.post(
      APP.HTTP_APPLY_URL + '/no-login/send-verification-code',
      {
        send_phone: sendPhone
      },
      {
        baseURL: APP.HTTP_URL2
      }
    )
  },
  loginByPhone(send_phone, verification_code) {
    return ETC_AXIOS.post('/auth/login-by-phone', {
      send_phone,
      verification_code,
      third_type: ETC.APP_LOGIN_TYPES[localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)]
    },
    {
      baseURL: APP.HTTP_URL2
    })
  },
  // 最珠海
  bestzhuhaiAuthGetInitCode (data) {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/auth/get-init-code', data)
  },
  // 最珠海
  bestzhuhaiAuthLogin (requestCode) {
    return ETC_AXIOS.post(APP.HTTP_URL2 + '/auth/best-zhuhai-login', { request_code: requestCode })
  }
}
